import { render, staticRenderFns } from "./docpack_new.vue?vue&type=template&id=7cefdc45&scoped=true&"
import script from "./docpack_new.vue?vue&type=script&lang=js&"
export * from "./docpack_new.vue?vue&type=script&lang=js&"
import style0 from "./docpack_new.vue?vue&type=style&index=0&id=7cefdc45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cefdc45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VSelect})
